var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:("move move--" + _vm.color),attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.$emit('clicked')}}})}
var staticRenderFns = []

export { render, staticRenderFns }